import isEmpty from 'lodash/isEmpty';
import * as Constants from '../constants';


export function loginAgent(idToken) {
  return {
    actionType: "custom",
    type: Constants.AGENT_LOGIN,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.agent.endpoint,
      method: Constants.apiMap.agent.method,
      body: { idToken },
    },
  };
}

export function loginSso(idToken, provider) {
  return {
    actionType: "custom",
    type: Constants.SSO_LOGIN,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.agent.endpoint,
      method: Constants.apiMap.agent.method,
      body: { idToken, provider },
    },
  };
}

export function setLeadCx(lead) {
  return {
    actionType: "custom",
    type: Constants.SET_CUSTOMER_LEAD,
    data: lead,
  };
}

export function setSalesForceLeadId(salesForceLeadId) {
  return {
    actionType: "custom",
    type: Constants.SET_SF_LEAD,
    data: salesForceLeadId,
  };
}

export function closeLead(lead, orderID) {
  return {
    actionType: "custom",
    type: Constants.CLOSE_LEAD,
    fetchConfig: {
      host: Constants.API_HOST,
      path: `${Constants.apiMap.closeLead.endpoint}/${lead}`,
      method: Constants.apiMap.closeLead.method,
      body: { convertedOrderId: orderID },
    },
  };
}

export function closeDxLead(orderID, salesForceId) {
  return {
    actionType: "custom",
    type: Constants.CLOSE_LEAD,
    fetchConfig: {
      host: Constants.MEDLIFE_LEAD_HOST[process.env.NODE_ENV],
      path: `${Constants.apiMap.closeDxLead.endpoint}`,
      method: Constants.apiMap.closeDxLead.method,
      headers: {
        'Content-Type': 'application/json',
        'X-Code': Constants.MEDLIFE_LEAD_X_CODE[process.env.NODE_ENV],
      },
      body: { orderId: orderID, sfId: salesForceId },
    },
  };
}

export function customerSearch(params) {
  return {
    actionType: "custom",
    type: Constants.CUSTOMER_SEARCH,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.customer.endpoint,
      method: Constants.apiMap.customer.method,
      body: {
        ...params,
        hasCalled: 'false',
      },
    },
  };
}

export function initiateCustomerSurvey() {
  return {
    actionType: "custom",
    type: Constants.CUSTOMER_SURVEY_INITIATED,
  };
}

export function fetchCityDetails(cityId) {
  return {
    actionType: "custom",
    type: Constants.FETCH_CITY_DETAILS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: `${Constants.apiMap.fetchCityDetails.endpoint}/${cityId}`,
      method: Constants.apiMap.fetchCityDetails.method,
    },
  };
}

export function searchNeighbourhood(queryParams) {
  return {
    actionType: "custom",
    type: Constants.SEARCH_NEIGHBOURHOOD,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.neighbourhood.endpoint,
      method: Constants.apiMap.neighbourhood.method,
      queryParams,
    },
  };
}

export function fetchDiagnosticsAvailability(params) {
  return {
    actionType: "custom",
    type: Constants.FETCH_DIAGNOSTICS_AVAILABILITY,
    fetchConfig: {
      host: Constants.API_HOST,
      path: `${Constants.apiMap.pincode.endpoint}/details/${params}`,
      method: Constants.apiMap.pincode.method,
    },
  };
}

export function isPincodeDeliverable(params) {
  return {
    actionType: "custom",
    type: Constants.PINCODE_DELIVERABLE,
    fetchConfig: {
      host: Constants.API_HOST,
      path: `${Constants.apiMap.pincode.endpoint}/${params.pincode}`,
      method: Constants.apiMap.pincode.method,
      queryParams: {},
    },
  };
}

export function sendOTP(contactNumber) {
  return {
    actionType: "custom",
    type: Constants.SEND_OTP,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.sendOTP.endpoint,
      method: Constants.apiMap.sendOTP.method,
      body: {
        contactNumber,
      },
    },
  };
}

export function setOrderType(orderType) {
  return {
    actionType: "custom",
    type: Constants.SET_ORDER_TYPE,
    data: orderType,
  };
}

export function searchProducts(params) {
  return (dispatch, getState) => {
    const { customer: { omsEnabled = false } = {} } = getState();
    params.omsEnabled = omsEnabled;
    return dispatch({
      actionType: "custom",
      type: Constants.PRODUCT_SEARCH,
      searchQuery: params.q,
      fetchConfig: {
        host: Constants.API_HOST,
        path: Constants.apiMap.search.endpoint,
        method: Constants.apiMap.search.method,
        queryParams: params,
        requestHeaders: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        }
      },
    });
  };
}

export function clearSearchedProducts() {
  return {
    actionType: "custom",
    type: Constants.PRODUCT_SEARCH_CLEAR,
  };
}

export function notifyCustomerDTP(productId) {
  return {
    actionType: "custom",
    type: Constants.NOTIY_CUSTOMER_DTP,
    fetchConfig: {
      host: Constants.API_HOST,
      path: `${Constants.apiMap.notifyCustomerDTP.endpoint}/${productId}/notify-me`,
      method: Constants.apiMap.notifyCustomerDTP.method,
    },
  };
}

export function searchDiagnosticsProducts(searchText, labID, pageID) {
  const queryParams = {
    q: searchText,
  };
  if (labID) {
    queryParams.selected_lab_id = labID;
  }
  if (pageID) {
    queryParams.page = pageID;
  }
  queryParams.channel = Constants.CHANNEL_PARAM;
  return {
    actionType: "custom",
    type: Constants.PRODUCT_SEARCH_DIAG,
    fetchConfig: {
      host: Constants.API_HOST_ALLOY_SEARCH,
      path: Constants.apiMap.diagnosticsSearch.endpoint,
      method: Constants.apiMap.diagnosticsSearch.method,
      queryParams,
    },
  };
}

function getCartStateParams(state) {

  let {
    orderParams: {
      selectedAddressId,
      paymentModeId,
      paymentModeSubId,
      optForWallet,
    },
    cart: { promocode, data = {} },
    loyalty,
  } = state;

  if (!data) {
    data = {};
  }

  const stateParams = {};
  const { promotionDetails = {} } = data;
  if (promocode && promocode.data && promocode.data.couponCode) {
    stateParams.promoCode = promocode.data.couponCode;
  } else if (promotionDetails && promotionDetails.code) {
    stateParams.promoCode = promotionDetails.code;
  }

  if (!isEmpty(loyalty.selectedVariant)) {
    stateParams.programId = loyalty.selectedVariant.programId;
    stateParams.variantId = loyalty.selectedVariant.variantId;
  }

  if (selectedAddressId) {
    stateParams.addressId = selectedAddressId;
  }
  if (paymentModeId) {
    stateParams.paymentId = paymentModeId;
  }
  if (paymentModeSubId) {
    stateParams.paymentSubId = paymentModeSubId;
  }
  stateParams.walletOptIn = optForWallet ? 1 : 0;

  return stateParams;
}

function stringifyCartItemPayload(payload = {}) {
  return Object.keys(payload).reduce((acc, key) => {
    const value = payload[key];
    if (value == null || typeof value === 'object') {
      acc[key] = value;
      return acc;
    }
    acc[key] = String(value);
    return acc;
  }, {});
}

function getDiagnosticsCartStateParams({
  orderParams: {
    selectedAddressId,
    paymentModeId,
    paymentModeSubId,
    optForWallet,
  },
  diagnosticsCart: { diagnosticsPromocode, selectedLPVariant={} },
}) {
  const stateParams = {};
  if (diagnosticsPromocode && diagnosticsPromocode.is_valid) {
    stateParams.promocode = diagnosticsPromocode.code;
  }
  if (selectedAddressId) {
    stateParams.addressId = selectedAddressId;
  }
  if (paymentModeId) {
    stateParams.paymentId = paymentModeId;
  }
  if (paymentModeSubId) {
    stateParams.paymentSubId = paymentModeSubId;
  }
  if(selectedLPVariant.id && selectedLPVariant.programId){
    stateParams.program_id = selectedLPVariant.programId;
    stateParams.variant_id = selectedLPVariant.id;
  }
  stateParams.walletOptIn = optForWallet ? 1 : 0;

  return stateParams;
}

function getDeliveryPreferencesStateParams({
  orderParams: { selectedAddressId },
  cart: { data: { promotionDetails } = {} },
}) {
  const stateParams = {
    addressId: String(selectedAddressId),
  };

  if (promotionDetails && promotionDetails.code && promotionDetails.isValid) {
    stateParams.promoCode = promotionDetails.code;
  }

  return stateParams;
}

function getCartAmountBifurcationStateParams({
  orderParams: {
    optForWallet,
    paymentModeId
  },
  loyalty
}) {
  const stateParams = {};

  if (paymentModeId) {
    stateParams.paymentId = paymentModeId;
  }

  if (!isEmpty(loyalty.selectedVariant)) {
    stateParams.programId = String(loyalty.selectedVariant.programId);
    stateParams.variantId = String(loyalty.selectedVariant.variantId);
  }

  stateParams.walletOptedIn = optForWallet ? 1 : 0;
  stateParams.refundOptIn = 1;

  return stateParams;
}


export function getCartItems(params = {}) {
  return (dispatch, getState) => {
    const stateParams = getCartStateParams(getState());

    return dispatch({
      actionType: "custom",
      type: Constants.GET_CART,
      fetchConfig: {
        host: Constants.API_HOST,
        path: Constants.apiMap.cart.endpoint,
        method: Constants.apiMap.cart.method,
        queryParams: { ...stateParams, ...params },
      },
    });
  };
}

export function addToCart(params = {}) {
  return (dispatch, getState) => {
    const stateParams = getCartStateParams(getState());

    return dispatch({
      actionType: "custom",
      type: Constants.ADD_TO_CART,
      fetchConfig: {
        host: Constants.API_HOST,
        path: Constants.apiMap.addToCart.endpoint,
        method: Constants.apiMap.addToCart.method,
        body: stringifyCartItemPayload({ ...stateParams, ...params }),
      },
    });
  };
}

export function removeFromCart(params) {
  return (dispatch, getState) => {
    const stateParams = getCartStateParams(getState());

    return dispatch({
      actionType: "custom",
      type: Constants.REMOVE_FROM_CART,
      fetchConfig: {
        host: Constants.API_HOST,
        path: `${Constants.apiMap.removeFromCart.endpoint}/${params.itemId}`,
        method: Constants.apiMap.removeFromCart.method,
        queryParams: stateParams,
      },
    });
  };
}

export function updateCart(params) {
  return {
    actionType: "custom",
    type: Constants.UPDATE_CART,
    fetchConfig: {
      host: Constants.API_HOST,
      path: `${Constants.apiMap.updateCart.endpoint}/${params.itemId}`,
      method: Constants.apiMap.updateCart.method,
      body: stringifyCartItemPayload({ quantity: params.quantity, responseType: 0 }),
    },
  };
}

export function getCartItemsV5(params = {}) {
  return (dispatch, getState) => {
    const stateParams = getCartStateParams(getState());
    return dispatch({
      actionType: "custom",
      type: Constants.GET_CART_V5,
      fetchConfig: {
        host: Constants.API_HOST,
        path: Constants.apiMap.cartV5.endpoint,
        method: Constants.apiMap.cartV5.method,
        queryParams: { ...stateParams, ...params },
      },
    });
  };
}

export function getLoyaltyData(params = {}) {
  return dispatch =>
     dispatch({
       actionType: "custom",
       type: Constants.GET_LOYALTY_DATA,
       fetchConfig: {
         host: Constants.API_HOST,
         path: Constants.apiMap.loyalty.endpoint,
         method: Constants.apiMap.loyalty.method,
         queryParams: params
       },
     });
}

export function setLoyaltyData(payload) {
  return { actionType: "custom", type: Constants.SELECT_VARIANT, payload };
}

export function removeLoyaltyData() {
  return { actionType: "custom", type: Constants.RESET_SELECTED_VARIANT_DATA };
}


export function saveNewAddress(params) {
  return {
    actionType: "custom",
    type: Constants.ADD_ADDRESS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.saveNewAddress.endpoint,
      method: Constants.apiMap.saveNewAddress.method,
      body: params,
    },
  };
}

export function editAddress(params) {
  return {
    actionType: "custom",
    type: Constants.EDIT_ADDRESS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: `${Constants.apiMap.editAddress.endpoint}/${params.id}`,
      method: Constants.apiMap.editAddress.method,
      body: params,
    },
  };
}

export function deleteAddress(id) {
  return {
    actionType: "custom",
    type: Constants.DELETE_ADDRESS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: `${Constants.apiMap.deleteAddress.endpoint}/${id}`,
      method: Constants.apiMap.deleteAddress.method,
      body: {},
    },
  };
}

export function getAddresses() {
  return {
    actionType: "custom",
    type: Constants.FETCH_ADDRESSES,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.fetchAddresses.endpoint,
      method: Constants.apiMap.fetchAddresses.method,
      queryParams: {},
    },
  };
}

export function selectAddress(addressObj) {
  return {
    actionType: "custom",
    type: Constants.SELECT_ADDRESS_SUCCESS,
    data: addressObj,
  };
}

export function selectAddressDiagnostics(address) {
  return {
    actionType: "custom",
    type: Constants.SELECT_ADDRESS_DIAGNOSTICS_SUCCESS,
    data: address,
  };
}

export function selectPatient(patient) {
  return {
    actionType: "custom",
    type: Constants.SELECT_PATIENT_SUCCESS,
    data: patient,
  };
}


export function setPromocode(params) {
  return {
    actionType: "custom",
    type: Constants.SET_PROMOCODE,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.promoCode.endpoint,
      method: Constants.apiMap.promoCode.method,
      body: params,
    },
  };
}
export function setDiagnosticsPromocode(data) {
  return {
    actionType: "custom",
    type: Constants.SET_DIAGNOSTICS_PROMOCODE_SUCCESS,
    data,
  };
}
export function createOrder(params) {
  return {
    actionType: "custom",
    type: Constants.CREATE_ORDER,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.createOrder.endpoint,
      method: Constants.apiMap.createOrder.method,
      body: params,
    },
  };
}

export function getOrderPlacementReasons() {
  return {
    actionType: "custom",
    type: Constants.GET_ORDER_PLACEMENT_REASON,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.getOrderPlacementReasons.endpoint,
      method: Constants.apiMap.getOrderPlacementReasons.method,
      queryParams: {},
    },
  };
}

export function resetPromocode() {
  return {
    actionType: "custom",
    type: Constants.RESET_PROMOCODE,
    data: {},
  };
}

export function resetDiagnosticsPromocode() {
  return {
    actionType: "custom",
    type: Constants.RESET_DIAGNOSTICS_PROMOCODE,
    data: {},
  };
}

export function resetOrderActions() {
  return {
    actionType: "custom",
    type: Constants.RESET_ORDER_ACTIONS,
  };
}

export function cancelOrder() {
  return {
    actionType: "custom",
    type: Constants.CANCEL_ORDER,
  };
}

export function logoutAgent() {
  return {
    actionType: "custom",
    type: Constants.AGENT_LOGOUT,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.agentLogout.endpoint,
      method: Constants.apiMap.agentLogout.method,
      body: {},
    },
  };
}

export function changeHeaderState(componentType) {
  return {
    actionType: "custom",
    type: componentType,
  };
}

export function setOrderParams(deilveryPreference) {
  return {
    actionType: "custom",
    type: Constants.SET_ORDER_PARAMS,
    data: deilveryPreference,
  };
}

export function setRxAvailability(rxAvailability) {
  return {
    actionType: "custom",
    type: Constants.SET_RX_AVAILABILITY_STATE,
    data: rxAvailability,
  };
}

export function fetchActiveRefills(params) {
  return {
    actionType: "custom",
    type: Constants.FETCH_ACTIVE_REFILL,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.fetchActiveRefills.endpoint,
      method: Constants.apiMap.fetchActiveRefills.method,
      body: params,
    },
  };
}

export function fetchDeliveredMedicines() {
  return {
    actionType: "custom",
    type: Constants.FETCH_DELIVERED_MEDICINES,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.fetchDeliveredMedicines.endpoint,
      method: Constants.apiMap.fetchDeliveredMedicines.method,
      queryParams: {},
    },
  };
}

export function fetchDeliveredOrders() {
  return {
    actionType: "custom",
    type: Constants.FETCH_DELIVERED_ORDERS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.fetchDeliveredOrders.endpoint,
      method: Constants.apiMap.fetchDeliveredOrders.method,
      queryParams: {},
    },
  };
}

export function fetchDeliveredOrdersV5() {
  return {
    actionType: "custom",
    type: Constants.FETCH_DELIVERED_ORDERS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.fetchDeliveredOrdersV5.endpoint,
      method: Constants.apiMap.fetchDeliveredOrdersV5.method,
      queryParams: {},
    },
  };
}

export function getLabServiceability(pincodes, selectedLab) {
  return {
    actionType: "custom",
    type: Constants.LOAD_LAB_SERVICEABILITY,
    fetchConfig: {
      host: Constants.API_HOST_ALLOY_SEARCH,
      path: Constants.apiMap.getLabServiceability.endpoint,
      method: Constants.apiMap.getLabServiceability.method,
      queryParams: { lab_id: selectedLab },
      body: { pincodes },
    },
  };
}

export function fetchOrderDetails(params, omsEnabled = false) {
  return {
    actionType: "custom",
    type: Constants.FETCH_ORDER,
    fetchConfig: {
      host: Constants.API_HOST,
      path: omsEnabled ? Constants.apiMap.parentOrderDetails.endpoint(params.orderId) : `${Constants.apiMap.fetchDeliveredOrders.endpoint}/${params.orderId}`,
      method: omsEnabled ? Constants.apiMap.parentOrderDetails.method : Constants.apiMap.fetchDeliveredOrders.method,
      queryParams: {},
    },
  };
}
export function customerProfileUpdate(params) {
  return {
    actionType: "custom",
    type: Constants.CUSTOMER_PROFILE_UPDATE,
    fetchConfig: {
      host: Constants.API_HOST,
      path: `${Constants.apiMap.customerProfileUpdate.endpoint}/${params.id}`,
      method: Constants.apiMap.customerProfileUpdate.method,
      body: params,
    },
  };
}

/**
 * @deprecated
 */
export function getPaymentGateways(params) {
  return {
    actionType: "custom",
    type: Constants.GET_PAYMENT_GATEWAYS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.getPaymentGateways.endpoint,
      method: Constants.apiMap.getPaymentGateways.method,
      queryParams: params,
    },
  };
}

export function getPrescriptionImages() {
  return {
    actionType: "custom",
    type: Constants.GET_PRESCRIPTION_IMAGES,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.getPrescriptionImages.endpoint,
      method: Constants.apiMap.getPrescriptionImages.method,
      queryParams: {},
    },
  };
}

export function setCustomerPincode(pincode) {
  return {
    actionType: "custom",
    type: Constants.SET_CUSTOMER_PINCODE,
    data: pincode,
  };
}

export function hotkeysPress(data) {
  return {
    ...data,
    actionType: "custom",
  };
}

export function openCMSUrlSubscription(URL) {
  return { url: URL, type: Constants.OPEN_CMS_URL_SUBSCRIPTION };
}

export function reorder(params, isNewOrderFlow) {
  return {
    actionType: "custom",
    type: Constants.PLACE_REORDER,
    fetchConfig: {
      host: Constants.API_HOST,
      path: `${Constants.apiMap.reorder.endpoint(isNewOrderFlow)}/${params.orderId}/reorder`,
      method: Constants.apiMap.reorder.method,
      body: { replaceItems: isNewOrderFlow ? !!params.shouldReplace : params.shouldReplace },
    },
  };
}

export function changeSearchText(text) {
  return {
    actionType: "custom",
    text,
    path: window.location.pathname,
    type: Constants.CHANGE_SEARCH_TEXT,
  };
}

export function saveImagesInStore(data) {
  return {
    actionType: "custom",
    type: Constants.SAVE_NEW_PRESCRIPTION,
    data,
  };
}

export function deleteImageFromStore(imageId) {
  return {
    actionType: "custom",
    type: Constants.DELETE_NEW_PRESCRIPTION,
    data: imageId,
  };
}

export function fetchS3UploadLinks(imgCount, pdfCount, omsEnabled = false) {
  const queryParams = { [omsEnabled ? 'imageCount' : 'count']: imgCount, pdfCount };
  return {
    actionType: "custom",
    type: Constants.GET_S3_UPLOAD_URL,
    fetchConfig: {
      host: Constants.API_HOST,
      path: omsEnabled ? Constants.apiMap.generateS3UrlV5.endpoint : Constants.apiMap.generateS3Url.endpoint,
      method: omsEnabled ? Constants.apiMap.generateS3UrlV5.method : Constants.apiMap.generateS3Url.method,
      queryParams
    },
  };
}

export function setDiagnosticOptIn(data) {
  return {
    actionType: "custom",
    type: Constants.SET_DIAGNOSTIC_OPT_IN,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.diagnosticsOptIn.endpoint,
      method: Constants.apiMap.diagnosticsOptIn.method,
      body: data,
    },
  };
}

export function fetchPatients(data) {
  return {
    actionType: "custom",
    type: Constants.FETCH_PATIENTS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.fetchPatients.endpoint,
      method: Constants.apiMap.fetchPatients.method,
      body: data,
    },
  };
}

export function getDiagosticsSlotDate(addId, params) {
  return {
    actionType: "custom",
    type: Constants.GET_DIAGNOSTICS_SLOTS_DATE,
    fetchConfig: {
      host: Constants.API_HOST_DIAG,
      path: `${Constants.apiMap.diagnosticsSlotList.endpoint}/${addId}`,
      method: Constants.apiMap.diagnosticsSlotList.method,
      queryParams: params,
    },
  };
}

export function deletePatient(tenantPatientId) {
  return {
    actionType: "custom",
    type: Constants.DELETE_PATIENT,
    fetchConfig: {
      host: Constants.API_HOST,
      path: `${Constants.apiMap.deletePatient.endpoint}/${tenantPatientId}/delete`,
      method: Constants.apiMap.deletePatient.method,
      body: {},
    },
  };
}

export function addPatient(params) {
  // TODO: isConsentGiven logic needs to be UI driven after Patient unification UI changes are done on OOC frontend.
  return {
    actionType: "custom",
    type: Constants.ADD_PATIENT,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.addPatient.endpoint,
      method: Constants.apiMap.addPatient.method,
      body: { ...params, isConsentGiven: false },
    },
  };
}

export function updatePatient(params) {
  // TODO: isConsentGiven logic needs to be UI driven after Patient unification UI changes are done on OOC frontend.
  return {
    actionType: "custom",
    type: Constants.UPDATE_PATIENT,
    fetchConfig: {
      host: Constants.API_HOST,
      path: `${Constants.apiMap.updatePatient.endpoint}/${params.tenantPatientId}/update`,
      method: Constants.apiMap.updatePatient.method,
      body: { ...params, isConsentGiven: false },
    },
  };
}

export function getDiagosticsSlotTime(date, cityID, params) {
  return {
    actionType: "custom",
    type: Constants.GET_DIAGNOSTICS_SLOTS_TIME,
    fetchConfig: {
      host: Constants.API_HOST_DIAG,
      path: `${Constants.apiMap.diagnosticsSlotTime.endpoint}/${date}/address-city/${cityID}`,
      method: Constants.apiMap.diagnosticsSlotTime.method,
      queryParams: params,
    },
  };
}

export function setDiagosticsSelectedSlot(slot) {
  return {
    actionType: "custom",
    type: Constants.SET_SELECTED_SLOT,
    data: slot,
  };
}

export function getDiagnosticsCart(params) {
  return (dispatch, getState) => {
    const stateParams = getDiagnosticsCartStateParams(getState());
    const pharmeasyWalletParam = { use_pharmeasy_wallet: true };

    return dispatch({
      actionType: "custom",
      type: Constants.GET_DIAGNOSTICS_CART,
      fetchConfig: {
        host: Constants.API_HOST_ALLOY,
        path: Constants.apiMap.diagnosticsGetCart.endpoint,
        method: Constants.apiMap.diagnosticsGetCart.method,
        queryParams: { ...stateParams, ...params, ...pharmeasyWalletParam },
      },
    });
  };
}

export function removeItem(id, type) {
  return {
    actionType: "custom",
    type: Constants.DELETE_DIAGNOSTICS_ITEM,
    fetchConfig: {
      host: Constants.API_HOST_ALLOY,
      path: Constants.apiMap.diagnosticsDeleteItem.endpoint,
      method: Constants.apiMap.diagnosticsDeleteItem.method,
      body: { item_id: id, item_type: type },
    },
  };
}

export function setSelectedLab(labDetails) {
  return {
    actionType: "custom",
    type: Constants.SET_SELECTED_LAB,
    data: labDetails,
  };
}

export function getAllAvailableLabs(itemId, itemType) {
  return {
    actionType: "custom",
    type: Constants.GET_AVAILABLE_LAB,
    fetchConfig: {
      host: Constants.API_HOST_ALLOY_SEARCH,
      path: `${Constants.apiMap.getLabs.endpoint}?item_id=${itemId}&item_type=${itemType}`,
      method: Constants.apiMap.getLabs.method,
    },
  };
}

export function getLabsAvailableToChangeSelectedLab(selectedLabId, cartItems) {
  return {
    actionType: "custom",
    type: Constants.GET_AVAILABLE_LABS_TO_CHANGE_SELECTED_LAB,
    fetchConfig: {
      host: Constants.API_HOST_ALLOY_SEARCH,
      path: Constants.apiMap.getAvailableLab.endpoint,
      method: Constants.apiMap.getAvailableLab.method,
      body: {
        tests: cartItems,
        selected_lab_id: selectedLabId,
      },
    },
  };
}

export function addToDiagCart(labId, testId, itemType) {
  return {
    actionType: "custom",
    type: Constants.ADD_TO_CART_DIAG,
    fetchConfig: {
      host: Constants.API_HOST_ALLOY,
      path: Constants.apiMap.atcDiag.endpoint,
      method: Constants.apiMap.atcDiag.method,
      body: {
        lab_details: { item_id: Number(labId) },
        test_details: { item_id: testId, item_type: itemType }
      },
    },
  };
}

export function setDiagnosticsLoyaltyData(payload) {
  return {
    actionType: "custom",
    type: Constants.SET_DIAGNOSTICS_SELECTED_LOYALTY_VARIANT,
    data: payload,
  };
}
export function removeDiagnosticsLoyaltyData() {
  return {
    actionType: "custom",
    type: Constants.RESET_DIAGNOSTICS_SELECTED_LOYALTY_VARIANT,
  };
}

export function changeLab(labID) {
  return {
    actionType: "custom",
    type: Constants.CHANGE_DIAGNOSTICS_LAB,
    fetchConfig: {
      host: Constants.API_HOST_ALLOY,
      path: Constants.apiMap.changeLab.endpoint,
      method: Constants.apiMap.changeLab.method,
      body: {
        lab_details: { item_id: labID },
      },
    },
  };
}

export function placeDiagnosticsOrder(orderParams) {
  return (dispatch, getState) => {
    const stateParams = getDiagnosticsCartStateParams(getState());

    return dispatch({
      actionType: "custom",
      type: Constants.PLACE_DIAGNOSTICS_ORDER,
      fetchConfig: {
        host: Constants.API_HOST_ALLOY,
        path: Constants.apiMap.placeDiagOrder.endpoint,
        method: Constants.apiMap.placeDiagOrder.method,
        body: { ...stateParams, ...orderParams },
      },
    });
  };
}

export function catalogConfig(orderParams) {
  return dispatch =>
    dispatch({
      actionType: 'custom',
      type: Constants.UNIFIED_PAYMENT_FEATURE_FLAG,
      fetchConfig: {
        host: Constants.API_HOST_DIAG,
        path: Constants.apiMap.fetchCatalogConfig.endpoint,
        method: Constants.apiMap.fetchCatalogConfig.method,
        queryParams: { ...orderParams },
      },
    });
}

export function getDiagnosticsOrderDetails(orderId) {
  return {
    actionType: "custom",
    type: Constants.GET_DIAGNOSTICS_ORDER_DETAILS,
    fetchConfig: {
      host: Constants.API_HOST_DIAG,
      path: `${Constants.apiMap.diagOrderDetails.endpoint}/${orderId}`,
      method: Constants.apiMap.diagOrderDetails.method,
    },
  };
}

export function physicalReportNeeded(value) {
  return {
    actionType: "custom",
    type: Constants.SET_PHYSICAL_REPORT_NEEDED,
    data: value,
  };
}

export function clearDiagSearch() {
  return {
    actionType: "custom",
    type: Constants.PRODUCT_SEARCH_DIAG_CLEAR,
  };
}

export function fetchProductAlternates(productId) {
  return {
    actionType: "custom",
    type: Constants.FETCH_PRODUCT_ALTERNATES,
    fetchConfig: {
      host: Constants.API_HOST,
      path: `${Constants.apiMap.getProductAlternates.endpoint}?productId=${productId}`,
      method: Constants.apiMap.getProductAlternates.method,
    },
  };
}

export function fetchSimilarProducts(productId) {
  return {
    actionType: "custom",
    type: Constants.FETCH_SIMILAR_PRODUCTS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: `${Constants.apiMap.getSimilarProducts.endpoint}?productId=${productId}`,
      method: Constants.apiMap.getSimilarProducts.method,
    },
  };
}

export function addSubstitutionRecord(data) {
  return {
    actionType: "custom",
    type: Constants.ADD_CART_SUBSTITUTION_RECORD,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.addSubstitutionRecord.endpoint,
      method: Constants.apiMap.addSubstitutionRecord.method,
      body: data,
    },
  };
}

export function addSubstitutionEventLog(data = []) {
  return (dispatch, getState) => {
    const {
      customer: { sessionId },
    } = getState();

    data = data.map((log) => {
      log.sessionId = sessionId;

      return log;
    });

    return dispatch({
      actionType: "custom",
      type: Constants.ADD_SUBSTITUTION_EVENT_LOG,
      fetchConfig: {
        host: Constants.API_HOST,
        path: Constants.apiMap.addSubstitutionEventLog.endpoint,
        method: Constants.apiMap.addSubstitutionEventLog.method,
        body: data,
      },
    });
  };
}

export function setSessionOrderMap(data) {
  return (dispatch, getState) => {
    const {
      customer: { sessionId },
    } = getState();

    data.sessionId = sessionId;

    return dispatch({
      actionType: "custom",
      type: Constants.SET_SESSION_ORDER_MAP,
      fetchConfig: {
        host: Constants.API_HOST,
        path: Constants.apiMap.setSessionOrderMap.endpoint,
        method: Constants.apiMap.setSessionOrderMap.method,
        body: data,
      },
    });
  };
}

export function fetchSubstitutedCartItems(data) {
  return {
    actionType: "custom",
    type: Constants.FETCH_CART_SUBSTITUTIONS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.fetchSubstitutedCartItems.endpoint,
      method: Constants.apiMap.fetchSubstitutedCartItems.method,
      body: data,
    },
  };
}

export function getSubstitutionReasons(type) {
  return {
    actionType: "custom",
    type: Constants.FETCH_SUBSTITUTION_REASONS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: `${Constants.apiMap.getSubstitutionReasons.endpoint}?type=${type}`,
      method: Constants.apiMap.getSubstitutionReasons.method,
    },
  };
}

export function postSubstitutionReasons(data) {
  return {
    actionType: "custom",
    type: Constants.POST_SUBSTITUTION_REASONS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.postSubstitutionReasons.endpoint,
      method: Constants.apiMap.postSubstitutionReasons.method,
      body: data,
    },
  };
}

export function saveSubstitutionReasons(data) {
  return {
    actionType: "custom",
    type: Constants.SAVE_SUBSTITUTION_REASONS,
    data,
  };
}

export function fetchPaymentMethods(addressId) {
  return (dispatch, getState) => {
    const { customer: { omsEnabled = false } = {} } = getState();
    return dispatch({
      actionType: "custom",
      type: Constants.FETCH_PAYMENT_METHODS,
      fetchConfig: {
        host: Constants.API_HOST,
        path: `${
          Constants.apiMap[
            omsEnabled ? "fetchPaymentMethodsV5" : "fetchPaymentMethods"
          ].endpoint
        }?orderType=0&addressId=${addressId}`,
        method:
          Constants.apiMap[
            omsEnabled ? "fetchPaymentMethodsV5" : "fetchPaymentMethods"
          ].method,
      },
    });
  };
}

export function fetchWalletDetails() {
  return {
    actionType: "custom",
    type: Constants.FETCH_WALLET_DETAILS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.fetchWalletDetails.endpoint,
      method: Constants.apiMap.fetchWalletDetails.method,
    },
  };
}

export function getRecommendedItems(currentProducts) {
  let path = `${Constants.apiMap.getRecommendedItems.endpoint}?touchpointId=7`;
  if (currentProducts.length) {
    currentProducts.forEach(id => {
      path += `&currentProducts[]=${id}`;
    });
  }
  return {
    actionType: "custom",
    type: Constants.GET_RECOMMENDED_ITEMS,
    fetchConfig: {
      host: Constants.API_HOST,
      path,
      method: Constants.apiMap.getRecommendedItems.method,
    },
  };
}

export function rejetRecommendedProduct(data) {
  data.touchpointId = 7;
  return {
    actionType: "custom",
    type: Constants.REJECT_RECOMMENDED_ITEMS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.rejectRecommendedItem.endpoint,
      method: Constants.apiMap.rejectRecommendedItem.method,
      body: data
    }
  };
}

export function getValidationOnSameOrder(paramsObj) {
  return (dispatch, getState) => {
    const { customer } = getState();

    return dispatch({
      actionType: 'custom',
      type: '',
      fetchConfig: {
        host: Constants.API_HOST_DIAG_CART,
        path: `${Constants.apiMap.postValidationOnSameOrder.endpoint}`,
        method: Constants.apiMap.postValidationOnSameOrder.method,
        body: { ...paramsObj },
        timeout: 5000,
        requestHeaders: {
          'X-Access-Token': customer.customerDetails.data ? customer.customerDetails.data.accessToken : '',
        },
      },
    });
  };
}

export function getDeliveryPreferences(params = {}) {
  return (dispatch, getState) => {
    const stateParams = getDeliveryPreferencesStateParams(getState());
    return dispatch({
      actionType: "custom",
      type: Constants.GET_DELIVERY_PREFERENCES,
      fetchConfig: {
        host: Constants.API_HOST,
        path: Constants.apiMap.deliveryPreferences.endpoint,
        method: Constants.apiMap.deliveryPreferences.method,
        queryParams: { ...stateParams, ...params },
      },
    });
  };
}

export function getCartAmountBifurcation(params = {}) {
  return (dispatch, getState) => {
    const stateParams = {
      ...getDeliveryPreferencesStateParams(getState()),
      ...getCartAmountBifurcationStateParams(getState()),
    };

    return dispatch({
      actionType: "custom",
      type: Constants.GET_CART_AMOUNT_BIFURCATION,
      fetchConfig: {
        host: Constants.API_HOST,
        path: Constants.apiMap.cartAmountBifurcation.endpoint,
        method: Constants.apiMap.cartAmountBifurcation.method,
        body: { ...stateParams, ...params },
      },
    });
  };
}

export function changeShipmentPreference(shipmentIndex, optionIndex) {
  return {
    actionType: "custom",
    type: Constants.CHANGE_SHIPMENT_PREFERENCE,
    data: {
      shipmentIndex,
      optionIndex
    },
  };
}

export function placeOrderV5(params = {}) {
  return (dispatch, getState) => {
    const stateParams = {
      ...getDeliveryPreferencesStateParams(getState()),
      ...getCartAmountBifurcationStateParams(getState()),
    };

    return dispatch({
      actionType: "custom",
      type: Constants.CREATE_ORDER,
      fetchConfig: {
        host: Constants.API_HOST,
        path: Constants.apiMap.placeOrderV5.endpoint,
        method: Constants.apiMap.placeOrderV5.method,
        body: { ...stateParams, ...params },
      },
    });
  };
}

export function fetchAllOfferTags() {
  return dispatch => dispatch({
    actionType: 'custom',
    type: Constants.FETCH_ALL_OFFER_TAGS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.fetchAllOfferTags.endpoint,
      method: Constants.apiMap.fetchAllOfferTags.method,
    },
  });
}

export function fetchOffers(params) {
  return dispatch => dispatch({
    actionType: 'custom',
    type: Constants.FETCH_OFFERS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.fetchOffers.endpoint,
      method: Constants.apiMap.fetchOffers.method,
      queryParams: params,
    },
  });
}

export function fetchPincodeServiceability(params) {
  return {
    actionType: "custom",
    type: Constants.PINCODE_SERVICEABLE,
    fetchConfig: {
      host: Constants.API_HOST_ALLOY_SEARCH,
      path: `${Constants.apiMap.postPincodeServiceability.endpoint}`,
      method: Constants.apiMap.postPincodeServiceability.method,
      body: { ...params },
    },
  };
}

export function resetSlotState() {
  return { actionType: 'custom', type: Constants.RESET_TO_INITIAL_SLOT_STATE };
}


export function fetchSpecialities() {
  return {
    actionType: 'custom',
    type: Constants.FETCH_SPECIALITIES,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.fetchSpecialities.endpoint,
      method: Constants.apiMap.fetchSpecialities.method,
    },
  };
}

export function setSelectedSpeciality(speciality) {
  return {
    actionType: 'custom',
    type: Constants.SET_SELECTED_SPECIALITY,
    data: speciality,
  };
}

export function fetchDoctors(concern) {
  return {
    actionType: 'custom',
    type: Constants.FETCH_DOCTORS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.fetchDoctors.endpoint,
      method: Constants.apiMap.fetchDoctors.method,
      queryParams: { category: concern },
    },
  };
}

export function setSelectedDoctor(doctor) {
  return {
    actionType: 'custom',
    type: Constants.SET_SELECTED_DOCTOR,
    data: doctor,
  };
}

export function fetchDocConsultSlots(doctorId) {
  return {
    actionType: 'custom',
    type: Constants.FETCH_SLOTS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.fetchDocConsultSlots.endpoint,
      method: Constants.apiMap.fetchDocConsultSlots.method,
      queryParams: { doctorId },
    },
  };
}

export function setSelectedDate(date) {
  return { actionType: 'custom', type: Constants.SET_SELECTED_DATE, data: date };
}

export function setDocConsultSlot(slot) {
  return { actionType: 'custom', type: Constants.SET_DOC_CONSULT_SLOT, data: slot };
}

export function setPatientDetails(details) {
  return { actionType: 'custom', type: Constants.SET_PATIENT_DETAILS, data: details };
}

export function setConsultMode(mode) {
  return { actionType: 'custom', type: Constants.SET_CONSULT_MODE, data: mode };
}

export function setSymptoms(symptoms) {
  return { actionType: 'custom', type: Constants.SET_SYMPTOMS, data: symptoms };
}

export function setDocConsultAppliedPromo(promoCode) {
  return { actionType: 'custom', type: Constants.SET_DOC_CONSULT_APPLIED_PROMO, data: promoCode };
}

export function fetchDocConsultBifurcation(params) {
  return {
    actionType: 'custom',
    type: Constants.FETCH_DOC_CONSULT_BIFURCATION,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.fetchDocConsultBifurcation.endpoint,
      method: Constants.apiMap.fetchDocConsultBifurcation.method,
      body: params,
    },
  };
}

export function createDocConsultOrder(params) {
  return {
    actionType: 'custom',
    type: Constants.CREATE_DOC_CONSULT_ORDER,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.createDocConsultOrder.endpoint,
      method: Constants.apiMap.createDocConsultOrder.method,
      body: params,
    },
  };
}

export function setSelectedGender(gender) {
  return {
    actionType: "custom",
    type: Constants.SET_SELECTED_GENDER,
    data: gender,
  };
}


// Service metadata
export function setServiceDetails(service) {
  return {
    type: Constants.SET_SERVICE_DETAILS,
    payload: service,
  };
}

export function resetServicePlatform() {
  return {
    type: Constants.RESET_SERVICE_PLATFORM,
  };
}

// Item details
export function fetchServiceItemDetails(itemId, successCb) {
  return {
    actionType: 'custom',
    type: Constants.FETCH_SERVICE_ITEM_DETAILS,
    successCb,
    fetchConfig: {
      host: Constants.API_HOST,
      path: `${Constants.apiMap.fetchServiceItemDetails.endpoint}/${itemId}`,
      method: Constants.apiMap.fetchServiceItemDetails.method,
    },
  };
}

// Categories & Subcategories
export function fetchCategoriesSubCategories(serviceId) {
  return {
    actionType: 'custom',
    type: Constants.FETCH_CATEGORIES_SUBCATEGORIES,
    fetchConfig: {
      host: Constants.API_HOST,
      path: `${Constants.apiMap.fetchCategoriesSubCategories.endpoint}/${serviceId}`,
      method: Constants.apiMap.fetchCategoriesSubCategories.method,
    },
  };
}

// Package selection
export function fetchServicePackages(serviceId, categoryId, subCategoryId) {
  const queryParams = { serviceId };

  // When omitted, API will return all items without filtering
  if (categoryId && categoryId !== -1) {
    queryParams.categoryId = categoryId;
  }
  if (subCategoryId && subCategoryId !== -1) {
    queryParams.subCategoryId = subCategoryId;
  }

  return {
    actionType: 'custom',
    type: Constants.FETCH_SERVICE_PACKAGES,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.fetchServicePackages.endpoint,
      method: Constants.apiMap.fetchServicePackages.method,
      queryParams,
    },
  };
}

// One item in a batch fetch
export function fetchServicePackagesBatchItem(categoryId, subCategoryId) {
  return {
    actionType: 'custom',
    type: Constants.FETCH_SERVICE_PACKAGES_BATCH_ITEM,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.fetchServicePackages.endpoint,
      method: Constants.apiMap.fetchServicePackages.method,
      queryParams: {
        categoryId,
        ...(subCategoryId ? { subcategoryId: subCategoryId } : {}),
      },
    },
  };
}

export function fetchServiceItemVariants(itemId) {
  return {
    actionType: 'custom',
    type: Constants.FETCH_SERVICE_ITEM_VARIANTS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: `${Constants.apiMap.fetchServiceItemVariants.endpoint}/${itemId}/variants`,
      method: Constants.apiMap.fetchServiceItemVariants.method,
    },
  };
}

export function setSelectedServicePackage(packageItem) {
  return {
    type: Constants.SET_SELECTED_SERVICE_PACKAGE,
    payload: packageItem,
  };
}

// Slot selection
export function fetchServiceSlots(serviceId) {
  return {
    actionType: 'custom',
    type: Constants.FETCH_SERVICE_SLOTS,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.fetchServiceSlots.endpoint,
      method: Constants.apiMap.fetchServiceSlots.method,
      queryParams: { service_id: serviceId },
    },
  };
}

export function setSelectedServiceDate(date) {
  return {
    actionType: 'custom',
    type: Constants.SET_SELECTED_SERVICE_DATE,
    data: date,
  };
}

export function setSelectedServiceSlot(slot) {
  return {
    actionType: 'custom',
    type: Constants.SET_SELECTED_SERVICE_SLOT,
    data: slot,
  };
}

export function setSelectedServiceFilter(filter) {
  return {
    actionType: 'custom',
    type: Constants.SET_SELECTED_SERVICE_FILTER,
    data: filter,
  };
}

// Bifurcation
export function fetchServiceBifurcation(params) {
  return {
    actionType: 'custom',
    type: Constants.FETCH_SERVICE_BIFURCATION,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.fetchServiceBifurcation.endpoint,
      method: Constants.apiMap.fetchServiceBifurcation.method,
      body: params,
    },
  };
}

// Order creation
export function createServiceOrder(params, successCb) {
  return {
    actionType: 'custom',
    type: Constants.CREATE_SERVICE_ORDER,
    successCb,
    fetchConfig: {
      host: Constants.API_HOST,
      path: Constants.apiMap.createServiceOrder.endpoint,
      method: Constants.apiMap.createServiceOrder.method,
      body: params,
    },
  };
}

